import { Button, FilterButton } from 'react-admin';
import { RefreshButton, TopToolbar } from 'ra-ui-materialui';
import { useNavigate } from 'react-router';
import { ADD_ROUTE, BIG_ADMIN, BIG_SUPER_ADMIN, ROLE_CREATE_USER } from '@/utils/CONST';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import LinkIcon from '@mui/icons-material/Link';
import { usePermissions } from 'react-admin';

interface Props {
    clientId?: string;
    siteId?: string;
}

const UsersListActions = ({ clientId, siteId }: Props) => {
    const navigate = useNavigate();
    const { permissions } = usePermissions();

    const handleCreateUser = () => {
        if (clientId) {
            navigate(`${ADD_ROUTE}/client/${clientId}`);
        } else if (siteId) {
            navigate(`${ADD_ROUTE}/site/${siteId}`);
        } else {
            navigate(ADD_ROUTE);
        }
    };

    const handleLinkUser = () => {
        navigate(ADD_ROUTE);
    };

    return (
        <TopToolbar sx={{ display: 'flex', alignItems: 'center' }}>
            <FilterButton />

            {permissions?.includes(ROLE_CREATE_USER) &&
                (permissions?.includes(BIG_SUPER_ADMIN) || permissions?.includes(BIG_ADMIN)) && (
                <>
                    <Button data-cy={'add-user'} onClick={handleCreateUser} label={'main.navigation.add_user'}>
                        <PlaylistAddIcon />
                    </Button>
                    <Button data-cy={'link-user'} onClick={handleLinkUser} label={'main.navigation.link_users'}>
                        <LinkIcon />
                    </Button>
                </>
            )}

            <RefreshButton
                data-cy='refresh-button'
                style={{
                    paddingLeft: '12px',
                    paddingRight: '12px',
                }}
            />
        </TopToolbar>
    );
};

export default UsersListActions;
